export const KANBAN_COLUMN_TOOLTIPS = {
  CREATED: 'Leads recién creados que aún no han sido atendidos.',
  HANDLED_BY_AI:
    'Leads que están siendo atendidos por la IA y todavía se encuentran en una fase temprana de la conversación.',
  INTERESTING_FOR_SALESMAN:
    'Leads atendidos por IA con una conversación interesante, listos para ser revisados por un ejecutivo.',
  UPLOADED_TO_CRM: 'Leads que han sido subidos al CRM y están listos para ser contactados.',
  ASSIGNED_TO_SALESMAN: 'Leads que han sido asignados a un ejecutivo de ventas y están esperando a ser atendidos.',
  PENDING_TO_BE_HANDLED: 'Leads que están pendientes de ser asignados a un ejecutivo.',
  PENDING_TO_BE_ASSIGNED:
    'Leads que la IA dejó pendientes de asignación porque el ejecutivo estaba fuera de su horario laboral; se asignan automáticamente en la mañana.',
  HANDLED_BY_SALESMAN: 'Leads que están siendo atendidos activamente por un ejecutivo de ventas.',
  CLOSED: 'Leads que han terminado el flujo y fueron cerrados',
} as const;
